/* eslint-disable no-magic-numbers */
export function abbreviateNumber(number: number, fixPointNotation = false): string {
  if (number < 1000) {
    return number.toString();
  }
  if (number < 1000000) {
    if (fixPointNotation) {
      const thousands = Number((number / 1000).toFixed(1)); // Wrapping it in Number will help convert 1.0 to just 1.
      return `${thousands}K`;
    } else {
      const thousands = Math.floor(number / 1000);
      return `${thousands}K`;
    }
  }
  const millions = Number((number / 1000000).toFixed(1)); // Wrapping it in Number will help convert 1.0 to just 1.
  return `${millions}M`;
}
